import { Card } from "primereact/card";
import React, { useState } from "react";
import SplitterImgBox from "./SplitterImgBox";
import PrimaryButton, { OutlinedButton } from "./CustomButtons";
import CustomImage from "./CustomImage";
import { useNavigate } from "react-router-dom";
import { slugify } from "../../utils/commonFunctions";
import EnquiryModal from "../Modals/EnquiryModal";

export default function ServiceCard({
  extraClass,
  BeforeImg,
  AfterImg,
  singleImage,
  title,
  detail,
  label,
  btndetail,
  servicebtn,
  showButton = true,
  onClick,
  hasBeforeAfterImage = true,
  style,
  serviceId,
  workId,
}) {
  const [isEnquiry, setIsEnquiry] = useState(false)

  const navigate = useNavigate();

  const onClickPlaceOrder = () => {
    navigate(`/orders/place-order/${serviceId}`);
  };

  const onClickViewDetails = () => {
    navigate(`/our-work/${workId}/${serviceId}`);
  };

  const onClickLearnMore = () => {
    if (title) {
      const name = slugify(title)
      navigate(`/service/${name}`);
    }
  };

  return (
    <div className={`service-card ${extraClass}`}>
      <Card className="border-round-xl">
        {hasBeforeAfterImage ? (
          <SplitterImgBox
            BeforeImg={BeforeImg}
            AfterImg={AfterImg}
            label={label}
            style={style}
          />
        ) : (
          <CustomImage
            src={singleImage}
            className="w-full border-round-xl"
            style={style}
          />
        )}

        <div
          className="flex align-items-center justify-content-between mt-3 cursor-pointer"
          onClick={onClick}
        >
          <h2 className="text-lg heading font-semibold m-0">{title}</h2>
          {btndetail ? (
            <PrimaryButton
              extraClassNames="w-6"
              label="View Details"
              onClick={onClickViewDetails}
            />
          ) : null}
        </div>

        {detail ? (
          <p className="text-gray-color text-sm font-normal">{detail}</p>
        ) : null}
        {showButton && (
          <OutlinedButton
            label="Learn More"
            extraClassNames="w-auto"
            outlined
            onClick={onClickLearnMore}
          />
        )}
        {servicebtn ? (
          <div className="flex gap-3">
            {title === "3D Rendering Service for Real Estate" ? <PrimaryButton
              label="Enquire Now"
              extraClassNames="w-auto px-6"
              onClick={() => setIsEnquiry(true)}
            /> : <PrimaryButton
              extraClassNames="w-auto"
              label="Place Order"
              onClick={onClickPlaceOrder}
            />}
            <OutlinedButton
              label="Learn More"
              extraClassNames="w-auto"
              outlined
              onClick={onClickLearnMore}
            />
          </div>
        ) : null}
      </Card>
      <EnquiryModal
        visible={isEnquiry}
        setVisible={setIsEnquiry}
      />
    </div>
  );
}
